import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/library/filter'
import '@/library/register-vee'

import 'bootstrap/js/src/dropdown'
import '@/library/components'
import '@/library/directive'
import '@/library/load-gmap'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created () {
  },
  render: h => h(App)
}).$mount('#app')
